import React from 'react';
import { styled, Button, SvgIcon } from '@teko/ui';
import { ThemeProps } from '@teko/ds-desktop';
import HTMLFlipBook from 'react-pageflip';

interface MagazineProps {
  images: Array<string>;
}

const StyleButton = styled(Button)(
  ({ theme }: ThemeProps) => `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  min-width: 36px;
  height: 36px;
  text-align: center;
  box-shadow: none;
  border-color: #ced4da;
  color: ${theme?.colors.primary};
  font-size: 12px;
  background-color: #fff;
  padding: 8px;
  margin: 5px;
  &:hover {
    background-color: #f4f4f4;
  }
`,
);

const MagazineWrapper = styled.div`
  display: flex;
`;
const ButtonWrapper = styled.div`
  position: relative;
  min-width: 44px;
`;

export const NewsMagazine: React.FC<MagazineProps> = ({
  images,
}: MagazineProps) => {
  // @ts-ignore
  // This lib doesn't export type :(
  let magazine;

  return (
    <MagazineWrapper>
      <ButtonWrapper>
        <StyleButton
          onClick={() => {
            // @ts-ignore
            magazine.pageFlip().flipPrev();
          }}
        >
          <SvgIcon name="chevron-back" size={12} color="red" />
        </StyleButton>
      </ButtonWrapper>
      {/* @ts-ignore */}
      <HTMLFlipBook
        width={600}
        height={900}
        size="stretch"
        ref={(ele) => (magazine = ele)}
      >
        {images.map((image, index) => {
          return (
            <div
              key={index}
              className="imageWrapper"
              dangerouslySetInnerHTML={{ __html: image }}
            />
          );
        })}
      </HTMLFlipBook>
      <ButtonWrapper>
        <StyleButton
          onClick={() => {
            // @ts-ignore
            magazine.pageFlip().flipNext();
          }}
        >
          <SvgIcon name="chevron-forward" size={12} color="red" />
        </StyleButton>
      </ButtonWrapper>
    </MagazineWrapper>
  );
};
